// src/components/subscription/MembershipPlans.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { PLAN_CONFIGS } from './config/constants';
// import { formatCurrency } from '../../utils/currency';
import { formatCurrency } from '../../../utils/currency';

import ConfirmationDialog from '../../restaurants/ConfirmationDialog';
// import api from '../../utils/api';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

const MembershipPlans = () => {
  const [currentPlan, setCurrentPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDowngradeDialog, setShowDowngradeDialog] = useState(false);
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [proratedAmount, setProratedAmount] = useState(null);
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    fetchCurrentSubscription();
  }, []);

  const fetchCurrentSubscription = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      const response = await api.get('/subscriptions/current', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCurrentPlan(response.data);
    } catch (error) {
      console.error('Error fetching subscription:', error);
      toast.error('Failed to load current subscription');
    } finally {
      setLoading(false);
    }
  };

  //   const handlePlanSelect = async (plan) => {
  //     if (!stripe || !elements) {
  //       toast.error('Payment system not available');
  //       return;
  //     }

  //     if (currentPlan?.planType === plan.id) {
  //       toast.info('You are already subscribed to this plan');
  //       return;
  //     }

  //     setSelectedPlan(plan);

  //     // Calculate if it's an upgrade or downgrade
  //     const isUpgrade =
  //       currentPlan &&
  //       PLAN_CONFIGS[currentPlan.planType].prices[currentPlan.currency] <
  //         plan.prices[currentPlan.currency];

  //     if (currentPlan) {
  //       if (isUpgrade) {
  //         try {
  //           const token = localStorage.getItem('ownerToken');
  //           console.log('here2');
  //           // First get proration amount
  //           const prorationResponse = await api.post(
  //             '/subscriptions/calculate-proration',
  //             {
  //               currentPlanId: currentPlan.planType,
  //               newPlanId: plan.id,
  //             },
  //             {
  //               headers: { Authorization: `Bearer ${token}` },
  //             }
  //           );

  //           setProratedAmount(prorationResponse.data.proratedAmount);
  //           setShowUpgradeDialog(true);
  //         } catch (error) {
  //           console.error('Error calculating proration:', error);
  //           toast.error('Failed to calculate upgrade cost');
  //         }
  //       } else {
  //         setShowDowngradeDialog(true);
  //       }
  //     } else {
  //       // New subscription
  //       console.log('here3');
  //       try {
  //         const token = localStorage.getItem('ownerToken');

  //         const response = await api.post(
  //           '/subscriptions/create',
  //           {
  //             planId: plan.id,
  //           },
  //           {
  //             headers: { Authorization: `Bearer ${token}` },
  //           }
  //         );

  //         navigate('/subscription/checkout', {
  //           state: {
  //             plan,
  //             clientSecret: response.data.clientSecret,
  //           },
  //         });
  //       } catch (error) {
  //         console.error('Error creating subscription:', error);
  //         toast.error('Failed to create subscription');
  //       }
  //     }
  //   };

  //   const handlePlanSelect = async (plan) => {
  //     console.log('111');
  //     if (!stripe || !elements) {
  //       toast.error('Payment system not available');
  //       return;
  //     }

  //     if (currentPlan?.planType === plan.id) {
  //       toast.info('You are already subscribed to this plan');
  //       return;
  //     }

  //     setSelectedPlan(plan);

  //     // Calculate if it's an upgrade or downgrade
  //     const currentPlanConfig = currentPlan?.planType
  //       ? PLAN_CONFIGS[currentPlan.planType]
  //       : null;
  //     const currency = currentPlan?.currency || 'usd';

  //     // Check if this is an upgrade (only if user has a current plan)
  //     const isUpgrade = currentPlanConfig
  //       ? currentPlanConfig.prices[currency] < plan.prices[currency]
  //       : false;

  //     if (currentPlan) {
  //       console.log(currentPlan);
  //       if (isUpgrade) {
  //         try {
  //           const token = localStorage.getItem('ownerToken');

  //           const prorationResponse = await api.post(
  //             '/subscriptions/calculate-proration',
  //             {
  //               currentPlanId: currentPlan.planType,
  //               newPlanId: plan.id,
  //             },
  //             {
  //               headers: { Authorization: `Bearer ${token}` },
  //             }
  //           );

  //           setProratedAmount(prorationResponse.data.proratedAmount);
  //           setShowUpgradeDialog(true);
  //         } catch (error) {
  //           console.error('Error calculating proration:', error);
  //           toast.error('Failed to calculate upgrade cost');
  //         }
  //       } else {
  //         setShowDowngradeDialog(true);
  //       }
  //     } else {
  //       // New subscription
  //       try {
  //         const token = localStorage.getItem('ownerToken');

  //         const response = await api.post(
  //           '/subscriptions/create',
  //           {
  //             planId: plan.id,
  //           },
  //           {
  //             headers: { Authorization: `Bearer ${token}` },
  //           }
  //         );

  //         navigate('/owner/test/checkout', {
  //           state: {
  //             plan,
  //             clientSecret: response.data.clientSecret,
  //           },
  //         });
  //       } catch (error) {
  //         console.error('Error creating subscription:', error);
  //         toast.error('Failed to create subscription');
  //       }
  //     }
  //   };

  //   const handleUpgradeConfirm = async () => {
  //     try {
  //       const token = localStorage.getItem('ownerToken');

  //       const response = await api.post(
  //         '/subscriptions/upgrade',
  //         {
  //           planId: selectedPlan.id,
  //         },
  //         {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }
  //       );

  //       navigate('/owner/test/checkout', {
  //         state: {
  //           plan: selectedPlan,
  //           clientSecret: response.data.clientSecret,
  //           proratedAmount,
  //           isUpgrade: true,
  //         },
  //       });
  //     } catch (error) {
  //       console.error('Error processing upgrade:', error);
  //       toast.error('Failed to process upgrade');
  //     }
  //   };

  //   const handlePlanSelect = async (plan) => {
  //     if (!stripe || !elements) {
  //       toast.error('Payment system not available');
  //       return;
  //     }

  //     // Check if user has an active subscription
  //     if (currentPlan.hasActiveSubscription) {
  //       // Handle upgrade/downgrade for existing subscription
  //       if (currentPlan.planType === plan.id) {
  //         toast.info('You are already subscribed to this plan');
  //         return;
  //       }

  //       setSelectedPlan(plan);

  //       // Calculate if it's an upgrade or downgrade
  //       const currentPlanConfig = PLAN_CONFIGS[currentPlan.planType];
  //       const currency = currentPlan.currency || 'usd';
  //       const isUpgrade =
  //         currentPlanConfig.prices[currency] < plan.prices[currency];

  //       if (isUpgrade) {
  //         try {
  //           const token = localStorage.getItem('ownerToken');
  //           const prorationResponse = await api.post(
  //             '/subscriptions/calculate-proration',
  //             {
  //               currentPlanId: currentPlan.planType,
  //               newPlanId: plan.id,
  //             },
  //             {
  //               headers: { Authorization: `Bearer ${token}` },
  //             }
  //           );

  //           setProratedAmount(prorationResponse.data.proratedAmount);
  //           setShowUpgradeDialog(true);
  //         } catch (error) {
  //           console.error('Error calculating proration:', error);
  //           toast.error('Failed to calculate upgrade cost');
  //         }
  //       } else {
  //         setShowDowngradeDialog(true);
  //       }
  //     } else {
  //       // Handle new subscription
  //       try {
  //         const token = localStorage.getItem('ownerToken');
  //         const response = await api.post(
  //           '/subscriptions/create',
  //           {
  //             planId: plan.id,
  //           },
  //           {
  //             headers: { Authorization: `Bearer ${token}` },
  //           }
  //         );

  //         navigate('/owner/test/checkout', {
  //           state: {
  //             plan,
  //             clientSecret: response.data.clientSecret,
  //           },
  //         });
  //       } catch (error) {
  //         console.error('Error creating subscription:', error);
  //         toast.error('Failed to create subscription');
  //       }
  //     }
  //   };

  const handlePlanSelect = async (plan) => {
    // Handle free plan users
    if (!currentPlan?.planType || currentPlan.planType === 'free') {
      // New subscription
      console.log('here111');
      navigate('/owner/test/checkout', {
        state: {
          plan,
          isUpgrade: false,
          isDowngrade: false,
          currency: 'usd', // Default currency for new subscriptions
        },
      });

      return;
    }

    // Prevent selecting the same plan
    if (currentPlan.planType === plan.id) {
      toast.info('You are already subscribed to this plan');
      return;
    }

    // Prevent selecting the same plan as pending downgrade
    if (
      currentPlan.pendingAction === 'downgrade' &&
      currentPlan.pendingPlan === plan.id
    ) {
      toast.info('You already have a pending downgrade to this plan');
      return;
    }

    // Handle active subscription changes
    // if (currentPlan.status === 'active') {
    const isUpgrade =
      PLAN_CONFIGS[currentPlan.planType].prices[currentPlan.currency] <
      plan.prices[currentPlan.currency];

    navigate('/owner/test/checkout', {
      state: {
        plan,
        currentPlan,
        isUpgrade,
        isDowngrade: !isUpgrade,
        currency: currentPlan.currency || 'usd',
      },
    });
    // }
  };

  // src/config/constants.js export const PLAN_CONFIGS = { basic: { id: 'basic', priceId: process.env.REACT_APP_STRIPE_BASIC_PRICE_ID, name: 'Basic Plan', description: 'Perfect for g

  //   const handlePlanSelect = async (plan) => {
  //     if (!plan || !plan.id) {
  //       console.error('Invalid plan selected');
  //       return;
  //     }

  //     if (!plan || !plan.prices) {
  //       console.error('Invalid plan structure:', plan);
  //       return;
  //     }

  //     if (currentPlan?.planType === plan.id) {
  //       toast.info('You are already subscribed to this plan');
  //       return;
  //     }

  //     setSelectedPlan(plan);

  //     if (!currentPlan.planType || currentPlan.type === 'free') {
  //       // New subscription
  //       //   navigate('/owner/test/checkout', {
  //       //     state: {
  //       //       plan,
  //       //       isUpgrade: false,
  //       //       isDowngrade: false,
  //       //       currency: 'usd', // Default currency for new subscriptions
  //       //     },
  //       //   });
  //       navigate(`/owner/test/checkout?planId=${plan.id}&action=${'create'}`);
  //     } else {
  //       // Calculate if it's an upgrade or downgrade
  //       const isUpgrade =
  //         PLAN_CONFIGS[currentPlan.planType].prices[currentPlan.currency] <
  //         plan.prices[currentPlan.currency];

  //       //   if (isUpgrade) {
  //       // try {
  //       //   const token = localStorage.getItem('ownerToken');
  //       //   const prorationResponse = await api.post(
  //       //     '/subscriptions/calculate-proration',
  //       //     {
  //       //       currentPlanId: currentPlan.planType,
  //       //       newPlanId: plan.id,
  //       //     },
  //       //     { headers: { Authorization: `Bearer ${token}` } }
  //       //   );

  //       //   setProratedAmount(prorationResponse.data.proratedAmount);
  //       //   setShowUpgradeDialog(true);
  //       // } catch (error) {
  //       //   console.error('Error calculating proration:', error);
  //       //   toast.error('Failed to calculate upgrade cost');
  //       // }
  //       //   navigate('/owner/test/checkout', {
  //       //     state: {
  //       //       plan,
  //       //       currentPlan,
  //       //       isUpgrade,
  //       //       isDowngrade: !isUpgrade,
  //       //       currency: currentPlan.currency || 'usd',
  //       //     },
  //       //   });
  //       if (isUpgrade) {
  //         navigate(`/owner/test/checkout?planId=${plan.id}&action=${'upgrade'}`);
  //       } else {
  //         navigate(
  //           `/owner/test/checkout?planId=${plan.id}&action=${'downgrade'}`
  //         );
  //       }
  //       //   } else {
  //       // For downgrades, show checkout page first
  //       //     navigate('/subscription/checkout', {
  //       //       state: {
  //       //         plan,
  //       //         planId: plan.id,
  //       //         currentPlan,
  //       //         isDowngrade: true,
  //       //         action: 'downgrade',
  //       //       },
  //       //     });
  //       //   }
  //     }
  //   };

  // For upgrades, keep existing confirm handler
  const handleUpgradeConfirm = async () => {
    try {
      const token = localStorage.getItem('ownerToken');
      const response = await api.post(
        '/subscriptions/upgrade',
        {
          planId: selectedPlan.id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      navigate('/subscription/checkout', {
        state: {
          plan: selectedPlan,
          clientSecret: response.data.clientSecret,
          proratedAmount,
          isUpgrade: true,
        },
      });
    } catch (error) {
      console.error('Error processing upgrade:', error);
      toast.error('Failed to process upgrade');
    }
  };

  const handleDowngradeConfirm = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      await api.post(
        '/subscriptions/downgrade',
        {
          planId: selectedPlan.id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success(
        `Your plan will be changed to ${selectedPlan.name} at the end of your billing period`
      );
      setShowDowngradeDialog(false);
      await fetchCurrentSubscription();
    } catch (error) {
      console.error('Error scheduling downgrade:', error);
      toast.error('Failed to schedule downgrade');
    }
  };

  const handleCancelDowngrade = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      await api.delete('/subscriptions/downgrade', {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Pending downgrade cancelled');
      await fetchCurrentSubscription();
    } catch (error) {
      console.error('Error cancelling downgrade:', error);
      toast.error('Failed to cancel downgrade');
    }
  };

  if (loading) {
    return (
      <div className='flex justify-center items-center min-h-screen'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500' />
      </div>
    );
  }

  return (
    <div className='container mx-auto px-4 py-8'>
      {/* Current Plan Banner */}
      {currentPlan && (
        <div className='bg-blue-50 border-l-4 border-blue-500 p-4 mb-8'>
          <p className='text-blue-700'>
            Current Plan:{' '}
            <span className='font-semibold capitalize'>
              {currentPlan.planType}
            </span>
            {currentPlan.pendingAction === 'cancel' && (
              <span className='ml-2'>
                (Cancels on{' '}
                {new Date(currentPlan.currentPeriodEnd).toLocaleDateString()})
              </span>
            )}
            {currentPlan.pendingAction === 'downgrade' && (
              <>
                <span className='ml-2'>
                  (Changes to {currentPlan.pendingPlan} on{' '}
                  {new Date(currentPlan.currentPeriodEnd).toLocaleDateString()})
                </span>
                <button
                  onClick={handleCancelDowngrade}
                  className='ml-4 text-sm text-blue-600 hover:text-blue-800 underline'
                >
                  Cancel Downgrade
                </button>
              </>
            )}
          </p>
          <p className='text-blue-600'>
            Credits: {currentPlan.credits.subscription} subscription +{' '}
            {currentPlan.credits.purchased} purchased
          </p>
        </div>
      )}

      {/* Plan Cards */}
      <div className='grid md:grid-cols-3 gap-6'>
        {Object.entries(PLAN_CONFIGS).map(([id, plan]) => (
          <div
            key={id}
            className={`border-2 rounded-lg p-6 cursor-pointer transition-all ${
              currentPlan?.planType === id
                ? 'border-blue-500 shadow-lg'
                : 'border-gray-200 hover:border-blue-300'
            }`}
            onClick={() => handlePlanSelect(plan)}
          >
            <h3 className='text-xl font-bold mb-2'>{plan.name}</h3>
            <p className='text-3xl font-bold mb-4'>
              {formatCurrency(
                plan.prices[currentPlan?.currency || 'usd'] / 100
              )}
              <span className='text-sm font-normal'>/month</span>
            </p>
            <p className='text-lg mb-4'>{plan.credits} credits/month</p>

            <ul className='space-y-2'>
              {plan.features.map((feature, index) => (
                <li key={index} className='flex items-center'>
                  <svg
                    className='w-4 h-4 mr-2 text-green-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth={2}
                      d='M5 13l4 4L19 7'
                    />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Upgrade Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={showUpgradeDialog}
        onClose={() => setShowUpgradeDialog(false)}
        onConfirm={handleUpgradeConfirm}
        title='Confirm Plan Upgrade'
      >
        <div className='space-y-4'>
          <p>You are upgrading to {selectedPlan?.name}.</p>
          <div className='bg-gray-50 p-4 rounded'>
            <h4 className='font-semibold mb-2'>Payment Summary</h4>
            <div className='flex justify-between'>
              <span>Prorated Amount Due Now:</span>
              <span>{formatCurrency(proratedAmount / 100)}</span>
            </div>
            <div className='flex justify-between mt-2'>
              <span>New Monthly Payment:</span>
              <span>
                {formatCurrency(
                  selectedPlan?.prices[currentPlan?.currency || 'usd'] / 100
                )}
                /month
              </span>
            </div>
          </div>
          <p className='text-sm text-gray-600'>
            Your new subscription will start immediately after payment.
          </p>
        </div>
      </ConfirmationDialog>

      {/* Downgrade Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={showDowngradeDialog}
        onClose={() => setShowDowngradeDialog(false)}
        onConfirm={handleDowngradeConfirm}
        title='Confirm Plan Change'
      >
        <div className='space-y-4'>
          <p>
            Your plan will be changed to {selectedPlan?.name} at the end of your
            current billing period (
            {new Date(currentPlan?.currentPeriodEnd).toLocaleDateString()}).
            You'll continue to have access to your current plan's features until
            then.
          </p>
          <p className='text-sm text-gray-600'>
            Your new rate of{' '}
            {formatCurrency(
              selectedPlan?.prices[currentPlan?.currency || 'usd'] / 100
            )}
            /month will start on{' '}
            {new Date(currentPlan?.currentPeriodEnd).toLocaleDateString()}.
          </p>
        </div>
      </ConfirmationDialog>
    </div>
  );
};

export default MembershipPlans;
